import DoubleTextBtn from './DoubleTextBtn';

export default DoubleTextBtn;



// WEBPACK FOOTER //
// ./scripts/elements/DoubleTextBtn/index.js